module.exports = __webpack_public_path__ + "static/fruitland-e82e168a9c72643efe4fe85223e9a8df.jpg";